export const ITEMS_PER_PAGE = 30; // Keep sync with backend - Thread.MSGS_PER_THREAD_PAGE
export const POST_DETAIL_MENU_MORE = 'POST_DETAIL_MENU_MORE';

import {
    PostDetailPageState,
    PostDetailState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialPostDetailState: PostDetailState = {
    pages: {},
    virtualPages: {},
    numberOfPages: null,
    contestId: null,
    contestAlreadyParticipated: false,
    commentsWithComplaintIds: [],
    commentToBeHighlighted: null,
    nextPostIds: [],
    similarPostIds: [],
    recentPostIds: [],
    counselling: null,
    campaign: null,
};

export const initialPostDetailPageState: PostDetailPageState = {
    commentIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

export const initialPostDetailVirtualPageState: PostDetailVirtualPageState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
};
